// extracted by mini-css-extract-plugin
module.exports =  {"rating-container":"BVtNcON","ratingContainer":"BVtNcON","rating":"nuVdHQz","score":"s2S5VAV","star":"WIf5wKl","count":"mZULPdY"};